// extracted by mini-css-extract-plugin
module.exports = {"avatar":"UserAvatar_avatar__aAQm1","lg":"UserAvatar_lg__GhpPs"};